import { createAxiosCancelable } from '@hmhco/core-network/src/axiosHelpers';
import requestHelper from '@hmhco/core-network/src/utils/requestHelper';
import { getIdentifiedPlatformConfig } from '@hmhco/login-config';

const getOrgUrl = orgPid => `/ids/v1/organizations/pid/${orgPid}`;

export default (pactConfig = {}) => {
  const { client, cancel, cancelToken, isCancel } = createAxiosCancelable({
    includeAuth: false,
  });
  const request = requestHelper({
    client,
    cancelToken,
    isCancel,
    baseURL: getIdentifiedPlatformConfig().hcpIdentityApiGateway,
    pactConfig,
  });
  return {
    getOrgInfo: orgPid => request.get(getOrgUrl(orgPid)),
    cancel,
  };
};
